import styled from "styled-components";

import { colors, typography, zIndex } from "src/assets/styles/settings";
import { triangle } from "polished";
import { TooltipProps } from ".";

const triangleDimension = {
  top: ["12px", "8px"],
  right: ["8px", "12px"],
  bottom: ["12px", "8px"],
  left: ["8px", "12px"]
};

function getTriange(direction: keyof typeof triangleDimension, color: string) {
  return triangle({
    pointingDirection: direction,
    width: triangleDimension[direction][0],
    height: triangleDimension[direction][1],
    foregroundColor: color
  });
}

const theme = {
  black: {
    background: colors.black_bekko,
    text: colors.white,
    opacity: 0.75
  },
  white: {
    background: colors.white,
    text: colors.black_bekko,
    opacity: 1
  }
};

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const StyledTooltip = styled.div<Pick<TooltipProps, "color">>`
  position: absolute;
  background: ${({ color }) => theme[color].background};
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  color: ${({ color }) => theme[color].text};
  display: inline-block;
  font-style: normal;
  font-size: ${typography.font_size.small};
  font-weight: ${typography.font_weight.normal};
  line-height: ${typography.line_height};
  opacity: ${({ color }) => theme[color].opacity};
  text-align: left;
  text-align: start;
  text-shadow: none;
  text-transform: none;
  white-space: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  width: max-content;
  max-width: 300px;
  z-index: ${zIndex.tooltip};

  &.c-tooltip--right {
    top: 50%;
    right: -8px;
    transform: translate3d(100%, -50%, 0);
  }

  &.c-tooltip--left {
    top: 50%;
    left: -8px;
    transform: translate3d(-100%, -50%, 0);
  }

  &.c-tooltip--top {
    top: -8px;
    left: 50%;
    transform: translate3d(-50%, -100%, 0);
  }

  &.c-tooltip--top-left {
    top: -8px;
    left: 50%;
    transform: translate3d(-13%, -100%, 0);
  }

  &.c-tooltip--top-right {
    top: -8px;
    left: 50%;
    transform: translate3d(-87%, -100%, 0);
  }

  &.c-tooltip--bottom {
    bottom: -8px;
    left: 50%;
    transform: translate3d(-50%, 100%, 0);
  }

  &.c-tooltip--bottom-left {
    bottom: -8px;
    left: 50%;
    transform: translate3d(-13%, 100%, 0);
  }

  &.c-tooltip--bottom-right {
    bottom: -8px;
    left: 50%;
    transform: translate3d(-87%, 100%, 0);
  }
`;

export const TooltipLabel = styled.div<Pick<TooltipProps, "color">>`
  border-radius: 4px;
  color: ${({ color }) => theme[color].text};
  width: 100%;
  padding: 4px 8px;
  text-align: center;
`;

export const TooltipArrow = styled.div<Pick<TooltipProps, "color">>`
  position: absolute;

  .c-tooltip--right & {
    ${({ color }) => getTriange("left", theme[color].background)}
    top: 50%;
    left: auto;
    margin-left: -7px;
    margin-top: -6px;
  }

  .c-tooltip--left & {
    ${({ color }) => getTriange("right", theme[color].background)}
    top: 50%;
    left: auto;
    right: -7px;
    margin-top: -6px;
  }

  .c-tooltip--top & {
    ${({ color }) => getTriange("bottom", theme[color].background)}
    top: auto;
    left: 50%;
    bottom: -7px;
    margin-left: -4px;
  }

  .c-tooltip--top-left & {
    ${({ color }) => getTriange("bottom", theme[color].background)}
    top: auto;
    left: 15%;
    bottom: -7px;
    margin-left: -4px;
  }

  .c-tooltip--top-right & {
    ${({ color }) => getTriange("bottom", theme[color].background)}
    top: auto;
    left: 85%;
    bottom: -7px;
    margin-left: -4px;
  }

  .c-tooltip--bottom & {
    ${({ color }) => getTriange("top", theme[color].background)}
    top: 0;
    left: 50%;
    margin-top: -7px;
    margin-left: -4px;
  }

  .c-tooltip--bottom-left & {
    ${({ color }) => getTriange("top", theme[color].background)}
    top: 0;
    left: 15%;
    margin-top: -7px;
    margin-left: -4px;
  }

  .c-tooltip--bottom-right & {
    ${({ color }) => getTriange("top", theme[color].background)}
    top: 0;
    left: 85%;
    margin-top: -7px;
    margin-left: -4px;
  }
`;
